import ko from 'knockout';

ko.extenders.defaultValue = (target, value) => {
	target.defaultValue = ko.observable(value);
};
